import AdminInstance from 'modules/admin/repository';

export const getServices = (page, size, search, filters, sort) => AdminInstance.getServices({
  page, size, search, filters, sort,
});

export const createService = (data) => AdminInstance.createService(data);

export const editService = (service, data) => AdminInstance.editService(service, data);

export const deleteService = (service) => AdminInstance.deleteService(service);

export const createServiceRequests = (data) => AdminInstance.createServicesRequestsAdmin(data);

export const deleteServicesRequest = (id) => AdminInstance.deleteServicesRequestAdmin(id);

export const editServicesRequest = (id, data) => AdminInstance.editServicesRequest(id, data);

export const getServicesRequests = (page, size, search, filters, sort) => AdminInstance.getServicesRequests({
  page, size, search, filters, sort,
});

export const getServicesRequestsStats = () => AdminInstance.getServicesRequestsStats();
